<template>
  <div class="alert-body">
    <b-list-group
      flush
      class="btn-list"
    >
      <b-list-group-item
        class="main-items"
      >
        {{ $t('DEBTIA_DESCRIPTION') }} : {{ moduleObject.module_settings.description }}
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_settings.await"
        class="main-items"
      >
        {{ $t('DEBTIA_WAIT_FOR') }} : {{ moduleObject.module_settings.await_days+' '+$t('DEBTIA_DAYS') }}
      </b-list-group-item>
      <b-list-group-item
        class="main-items"
      >
        {{ $t('DEBTIA_RECIPIENT') }} : {{ moduleObject.module_settings.recipient }}
      </b-list-group-item>
    </b-list-group>
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <user-action-left-side
          :module-buttons="moduleObject.module_settings.buttons"
          :module-id="moduleObject.id"
        />
      </b-col>
      <b-col
        cols="12"
        md="8"
        class="details-section"
      >
        <user-action-right-side
          :button-modules="buttonModules"
          :module-id="moduleObject.id"
          :action-id="userActionId"
          :parent-id="parentModule"
          :active-button-id="activeButtonId"
          :main-div-id="mainDivId"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
// import axios from '@axios'
// import Ripple from 'vue-ripple-directive'
// import i18n from '@/libs/i18n'
import UserActionLeftSide from './UserActionLeftSide.vue'
import UserActionRightSide from './UserActionRightSide.vue'

export default {
  components: {
    // BCard,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    UserActionLeftSide,
    UserActionRightSide,
  },
  props: {
    moduleObject: {
      type: Object,
      required: true,
    },
    buttonModules: {
      type: Array,
      required: true,
    },
    userActionId: {
      type: Number,
      required: true,
    },
    parentModule: {
      type: Number,
      required: true,
    },
    activeButtonId: {
      type: Number,
      required: true,
    },
    mainDivId: {
      type: Number,
      required: true,
    },
  },
  watch: {
  },
  created() {
  },
  methods: {
  },
}
</script>
